<template>
  <div class="services">
    <div class="site-content">
      <div
        class="page-header"
        :style="{backgroundImage:`url(${require('../assets/images/subheader-3.jpg')})`}"
        style="background:no-repeat center center;"
      >
        <div class="container">
          <div class="breadc-box no-line">
            <div class="row">
              <div class="col-md-12">
                <h2 class="page-title">软件下载</h2>
                <ul id="breadcrumbs" class="breadcrumbs none-style">
                  <li>
                    <router-link :to="{name: 'home'}" class="active_item" exact>首页</router-link>
                  </li>
                  <li class="active">技术服务</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div class="container">
          <div class="row flex-row">
            <div class="col-sm-6 col-sm-offset-1 col-xs-12">
              <h2>操作文档</h2>
              <br />
            </div>
            <div class="col-sm-5 col-xs-12 align-self-center">
              <div class="career-download">
                <a href="#" class="btn btn-border btn-download">
                  <span class="text-primary">下载文档</span>
                  <i class="fa fa-download"></i>
                </a>
              </div>
            </div>
          </div>

          <hr>
          <div class="industris-space-90 sm-hidden"></div>
          <div class="row flex-row">
            <div class="col-sm-6 col-sm-offset-1 col-xs-12">
              <h2>视频下载</h2>
              <br />
            </div>
            <div class="col-sm-5 col-xs-12 align-self-center">
              <div class="career-download">
                <a href="#" class="btn btn-border btn-download">
                  <span class="text-primary">下载视频</span>
                  <i class="fa fa-download"></i>
                </a>
              </div>
            </div>
          </div>

          <hr>
          <div class="industris-space-90 sm-hidden"></div>
          <div class="row flex-row">
            <div class="col-sm-6 col-sm-offset-1 col-xs-12">
              <h2>软件下载</h2>
              <br />
            </div>
            <div class="col-sm-5 col-xs-12 align-self-center">
              <div class="career-download">
                <a href="#" class="btn btn-border btn-download">
                  <span class="text-primary">下载地址</span>
                  <i class="fa fa-download"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "download",
  components: {},
};
</script>

<style>
.fa-play {
  color: #1a94e6;
}
</style>



// WEBPACK FOOTER //
// src/pages/download.vue